import {BaseAnalyticsEvent} from "../../../../../infrastructure/models/analytics/base-analytics-event";
import {GoogleAnalyticsEventModel} from "../../../../../third-party-services/analytics/google-analytics/google-analytics-event-model";
import {BETTING_PROMOTION} from "../bettin-ptomotion.module.consts";

export class BettingPromotionClickAnalyticsEvent extends BaseAnalyticsEvent {
  version: String;
  timeShown: Number;
  clickType: Number;
  bookieLinkUrl: String;
  guid: Number;
  bookieId: Number;
  clientId: String;
  clientSessionId: String;
  imageUrl: String;
  mainText: String;
  secondaryTextTerm: String;

  constructor(params) {
    super('', 'click', 'betting-promotion');

    this.version = params.version;
    this.timeShown = params.timeShown;
    this.clickType = params.clickType;
    this.bookieLinkUrl = params.bookieLinkUrl;
    this.textType = params.textType;
    this.guid = params.guid;
    this.bookieId = params.bookieId;
    this.clientId = params.ga4ClientId;
    this.clientSessionId = params.ga4SessionId;
    this.imageUrl = params.imageUrl;
    this.mainText = params.mainText;
    this.secondaryTextTerm = params.secondaryTextTerm;
  }

  get properties() {
    const properties = super.properties;

    properties.version = this.version;
    properties.timeShown = this.timeShown;
    properties.clickType = this.clickType;
    properties.bookieLinkUrl = this.bookieLinkUrl;
    properties.textType = this.textType;
    properties.guid = this.guid;
    properties.bookieId = this.bookieId;
    properties.clientId = this.clientId;
    properties.clientSessionId = this.clientSessionId;
    properties.imageUrl = this.imageUrl;
    properties.mainText = this.mainText;
    properties.secondaryTextTerm = this.secondaryTextTerm;

    return properties;
  }

  get googleAnalyticsEvent(): null {
    if(this.clickType === BETTING_PROMOTION.CLICK_TYPE.link) {
      const eventName = this.resolveEventName();
      return new GoogleAnalyticsEventModel(eventName, {
        version: this.version,
        timeShown: this.timeShown,
        clickType: this.clickType,
        bookieLinkUrl: this.bookieLinkUrl,
        textType: this.textType,
        guid: this.guid,
        bookieId: this.bookieId,
      })
    }

    return null;
  }
}
